import { render, staticRenderFns } from "./indexCopy.vue?vue&type=template&id=739aa582&scoped=true"
import script from "./indexCopy.vue?vue&type=script&lang=js"
export * from "./indexCopy.vue?vue&type=script&lang=js"
import style0 from "./indexCopy.vue?vue&type=style&index=0&id=739aa582&lang=css"
import style1 from "./indexCopy.vue?vue&type=style&index=1&id=739aa582&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739aa582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('739aa582')) {
      api.createRecord('739aa582', component.options)
    } else {
      api.reload('739aa582', component.options)
    }
    module.hot.accept("./indexCopy.vue?vue&type=template&id=739aa582&scoped=true", function () {
      api.rerender('739aa582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/indexCopy.vue"
export default component.exports